import React from 'react'
import { graphql, useStaticQuery } from 'gatsby';
import { styled } from '../../styles/stitches.config';
import BackgroundImage from 'gatsby-background-image';

const HeaderSection = () => {

    const data = useStaticQuery(
        graphql`
          query {
            allFile: file(name: { eq: "ourstoryimage" }) {
              childImageSharp {
                fluid(quality: 100, maxWidth: 1920) {
                    ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        `
    )

    const imageData = data.allFile.childImageSharp.fluid;

    const Section = styled(BackgroundImage, {
        color: 'white',
        display: 'flex',
        flexFlow: 'column wrap',
        height: '100vh',
        maxHeight: '700px',
        fontFamily: '$default',
        padding: '140px 40px',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        '@bp1': {
            height: '700px',
            padding: '80px 40px',
        },
        '& h2': {
            fontSize: '60px',
            lineHeight: '1.2',
            '@bp1': {
                fontSize: '48px',
                lineHeight: '1.2',
            },
        },
    });

    return (
        <Section fluid={imageData}>
            <h2>Our Story</h2>
        </Section>
    )
}

export default HeaderSection
